/**
 * Database Keys for Order Collection
 */

export const ORDER_KEYS = {
  ORDER_SHORTCODE: {
    label: 'Order Shortcode',
    value: 'Order_shortcode',
  },
  PLANNED_DELIVERY_DATE: {
    label: 'Planned Delivery Date',
    value: 'Planned_DeliveryDate',
  },
  PREPARED_BY: { label: 'Prepared By', value: 'Prepared_by' },
  DELIVERY_PROVIDER: { label: 'Delivery Provider', value: 'Delivery_provider' },
  ORDER_VALUE_EXCLUV_TAX: {
    label: 'Order Value Excluv Tax',
    value: 'order_value_excluv_tax',
  },
  VAT_AMOUNT: { label: 'Vat Amount', value: 'vat_amount' },
  SERVICE_FEE: { label: 'Service Fee', value: 'service_fee' },
  DELIVERY_FEE: { label: 'Delivery Fee', value: 'delivery_fee' },
  CUSTOMER_NAME: { label: 'Customer Name', value: 'customer_Name' },
  CUSTOMER_ADDRESS: { label: 'Customer Address', value: 'customer_Address' },
  CUSTOMER_ADDRESS2: { label: 'Customer Address2', value: 'customer_Address2' },
  AREA: { label: 'Area', value: 'Area' },
  CITY: { label: 'City', value: 'City' },
  COUNTRY: { label: 'Country', value: 'Country' },
  LATITUDE: { label: 'Latitude', value: 'latitude' },
  LONGITUDE: { label: 'Longitude', value: 'longitude' },
  CONTACT: { label: 'Contact', value: 'Contact' },
}

export const ORDER_TABLE_FIELDS = {
  ...ORDER_KEYS,
  ORDER_NO: { label: 'Order No', value: 'order_no' },
  STORE_CODE: { label: 'Store Code', value: 'Store_code' },
  PRODUCTS: { label: 'Products', value: 'products' },
  PAYMENT: { label: 'Payment', value: 'payment' },
  ORDER_PLACE_DATETIME: {
    label: 'Order Place Datetime',
    value: 'order_place_datetime',
  },
  ORDER_VALUE_INCLV_TAX: {
    label: 'Order Value Inclv Tax',
    value: 'order_value_inclv_tax',
  },
  AGGREGATOR_CODE: { label: 'Aggregator Code', value: 'Aggregator_Code' },
  AGGREGATOR_NAME: { label: 'Aggregator Name', value: 'Aggregator_Name' },
  STORE_NAME: { label: 'Store Name', value: 'storeName' },
  DELIVERY_SLOT: { label: 'Delivery Slot', value: 'deliverySlot' },
  DELIVERY_METHOD: { label: 'Delivery Method', value: 'deliveryMethod' },
  STATUS: { label: 'Order Status', value: 'status' },
  ERP_SYNC: { label: 'ERP Sync', value: 'erpSync' },
  LAST_MILE: { label: 'Last Mile', value: 'lastMile' },
  LAST_MILE_SYNC: { label: 'Last Mile Sync', value: 'lastMileSync' },
  INVOICE_NO: { label: 'Invoice Number', value: 'invoiceNo' },
  AGGREGATOR_PRICE: { label: 'Aggregator Price', value: 'systemPrice' },
  ORDER_POSTING_DATE: { label: 'Order Posting Date', value: 'createdAt' },
  ON_HOLD_ORDER: { label: 'On Hold Orders', value: 'onHold' },
  EMP_ID: { label: 'Employee ID', value: 'empId' },
  IS_POS_ORDER: { label: 'Is POS Order', value: 'isPosOrder' },
  IS_GRUBTECH_ORDER: { label: 'Is Grubtech Order', value: 'isGrubtechOrder' },
  POWER_BI_SYNC: { label: 'Power BI Sync', value: 'powerBiSync' },
  KDS_ELIGIBLE: { label: 'KDS Eligible', value: 'isKdsEligible' },
  IS_DRAFT: { label: 'Is Draft', value: 'isDraft' },
  KDS_SYNCED: { label: 'KDS Synced', value: 'kdsSynced' },
  POWER_BI_SYNCED: { label: 'Power BI Synced', value: 'powerBiSynced' },
  DRIVER_ID: { label: 'Driver Id', value: 'driverId' },
  BRAND_NAME: { label: 'Brand Name', value: 'brandName' },
  BRAND_ID: { label: 'Brand Id', value: 'brandId' },
}

export const ORDER_STATUS = {
  WAITING_FOR_DRIVER: 'Waiting for Driver',
  AGGREGATOR_LM: 'Aggregator LM',
  OUT_FOR_DELIVERY: 'Out for Delivery',
  DELIVERED: 'Delivered',
  DELIVERY_FAILED: 'Delivery Failed',
  CANCELED: 'Canceled',
  PENDING_FOR_PICKUP: 'Pending for pickup',
  ON_HOLD: 'On hold',
  PICKING_IN_PROGRESS: 'Picking in progress',
  VOID: 'Void',
  COMPLETED: 'Completed',
  ORDER_PLACED: 'Order Placed',
  UNDER_SUBSTITUTION: 'Under Substitution',
  PICKING_COMPLETED: 'Picking Completed',
  PICKED_UP: 'Pickedup by Driver',
  ACCEPTED: 'Accepted',
  STARTED: 'Started',
  PREPARED: 'Prepared',
  DISPATCHED: 'Dispatched',
  DENIED: 'Denied by Driver',
}

export const ORDER_STATUS_CLASSES = {
  [ORDER_STATUS.WAITING_FOR_DRIVER]: 'bg-yellow-200 text-gray-900',
  [ORDER_STATUS.AGGREGATOR_LM]: 'bg-green-300 text-gray-900',
  [ORDER_STATUS.OUT_FOR_DELIVERY]: 'bg-blue-600 text-white',
  [ORDER_STATUS.DELIVERED]: 'bg-green-300 text-gray-900',
  [ORDER_STATUS.DELIVERY_FAILED]: 'bg-red-500 text-white',
  [ORDER_STATUS.CANCELED]: 'bg-gray-300 text-gray-900',

  [ORDER_STATUS.PENDING_FOR_PICKUP]: 'bg-slate-400 text-white',
  [ORDER_STATUS.PICKING_IN_PROGRESS]: 'bg-indigo-500 text-white',
  [ORDER_STATUS.PICKING_COMPLETED]: 'bg-purple-500 text-white',

  [ORDER_STATUS.ON_HOLD]: 'bg-yellow-400 text-gray-900',
  [ORDER_STATUS.UNDER_SUBSTITUTION]: 'bg-orange-400 text-gray-900',

  [ORDER_STATUS.ORDER_PLACED]: 'bg-cyan-500 text-white',
  [ORDER_STATUS.VOID]: 'bg-red-700 text-white',

  [ORDER_STATUS.COMPLETED]: 'bg-emerald-500 text-white',
  [ORDER_STATUS.ACCEPTED]: 'bg-cyan-500 text-white',
  [ORDER_STATUS.STARTED]: 'bg-sky-500 text-white',
  [ORDER_STATUS.PREPARED]: 'bg-violet-500 text-white',
  [ORDER_STATUS.DISPATCHED]: 'bg-blue-400 text-white',
  [ORDER_STATUS.PICKED_UP]: 'bg-orange-500 text-white',
  [ORDER_STATUS.DENIED]: 'bg-red-300 text-gray-900',
}

export const HOLD_ACTIONS = {
  STORE_FIX: 'STORE_FIX',
  BARCODE_FIX: 'BARCODE_FIX',
  PRODUCT_CHANGE: 'PRODUCT_CHANGE',
} as const
